import GLightbox from 'glightbox';

export function initLightbox() {
  const elements = document.querySelectorAll('.glightbox');
  if (elements.length === 0) return;

  GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    loop: true,
    autoplayVideos: false,
    openEffect: 'zoom',
    closeEffect: 'zoom',
    slideEffect: 'slide',
  });
}
